export default "__VITE_ASSET__DlJg01cI__"